module.exports = __webpack_public_path__ + "static/img/gaozhonglishi7.1d07d232.jpg";